export enum SafetyAssessmentStatus {
	YES = 0,
	NO = 1,
    UNKNOWN = 2,
}